import AuthProvider from "./auth"
import BannerProvider from "./banner"
import PermissionProvider from "./permissions"
import QueryProvider from "./query"

const AppProviders: React.FC = ({ children }) => {
  return (
    <QueryProvider>
      <AuthProvider>
        <PermissionProvider>
          <BannerProvider>{children}</BannerProvider>
        </PermissionProvider>
      </AuthProvider>
    </QueryProvider>
  )
}

export default AppProviders
